import { Component, OnInit, OnDestroy, Inject } from "@angular/core";
import { JhaThemingService } from "@jkhy/responsive-ui-angular/jha-theme";
import {
  JhaPubSubService,
  JhaPubSubMessage,
} from "@jkhy/responsive-ui-angular/jha-responsive-core";
import { Subscription } from "rxjs";
import { DataService } from "../../services/data.service";
import { PFrameRoutes } from "src/app/shared/pframe-routes";
import { Router } from "@angular/router";
import { PageLoaderNames } from "src/app/features/page-loader/page-loader.model";
import { environment } from "src/environments/environment";

@Component({
  selector: "main-nav",
  templateUrl: "./main-nav.component.html",
  styleUrls: ["./main-nav.component.scss"],
  providers: [JhaThemingService],
})
export class MainNavComponent implements OnInit, OnDestroy {
  public hideNav = false;
  public loggedIn = false;
  private subscriptions: Subscription[] = [];
  public isInXperience = false;
  public hasPowerDocPermission = false;
  public hasPowerScreenPermission = false;
  public hasPowerBatchPermission = false;
  public hasSystemDashboardPermission = false;
  public hasSymProfilePermission = false;
  public hasUserManagementPermission = false;
  public hasInstManagementPermission = false;
  public hasUserForumPermission = false;
  public hasDeviceProfilePermission = false;
  public hasPowerAdPermission = false;
  public hasServiceConfigPermission = false;
  public hasManageSymProfilePermission = false;
  public hasManageRoutesPermission = false;
  public hasServiceDefinitionPermission = false;
  public hasGuestUserPermission = false;
  public hasLogsPermission = false;
  public hasManageProjectPermission = false;
  public hasMyAppStorePermission = false;
  public hasReleaseNotesPermission = false;
  public hasHostManagementPermission = false;
  public hasAuditLogsPermission = false;
  public userProfile: any;
  public permissionMap: any = {};
  public authenticated = false;
  public hasPermissions = false;
  public isBusy = false;

  constructor(
    @Inject(JhaPubSubService) private pubSubService: JhaPubSubService,
    private dataService: DataService,
    private themingService: JhaThemingService,
    private router: Router
  ) {}

  public ngOnInit(): void {
    this.subscriptions.push(
      this.pubSubService.Stream.subscribe((pubSubMessage) =>
        this.processMessage(pubSubMessage)
      )
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  public navigateTo(comp) {
    let rlocation;

    if (document.location.hostname == "localhost") {
      rlocation = environment.devJHAPF;
    } else {
      rlocation = "https://" + document.location.hostname;
    }

    switch (comp) {
      case "profile-configuration":
        this.router.navigate([PFrameRoutes.profileConfiguration], {
          state: {
            baseurl: rlocation + PageLoaderNames.SYMYTAR_DA_QUEST,
            appname: "symProfileManager",
          },
        });
        break;
      case "service-configuration":
        this.router.navigate([PFrameRoutes.serviceConfiguration], {
          state: {
            baseurl: rlocation + PageLoaderNames.SYMYTAR_DA_QUEST,
            appname: "serviceConfigBlueprint",
          },
        });
        break;
      case "audit-logs":
        this.router.navigate([PFrameRoutes.auditLogs], {
          state: {
            baseurl: rlocation + PageLoaderNames.SYMYTAR_DA_QUEST,
            appname: "auditLogs",
            currentWKSInst: this.dataService.getCurrentInst(),
          },
        });
        break;
      case "manage-project":
        this.router.navigate([PFrameRoutes.manageProject], {
          state: {
            baseurl: rlocation + PageLoaderNames.SYMYTAR_DA_QUEST,
            appname: "packageV2ServiceConfig",
          },
        });
        break;
      default:
        this.router.navigate([comp]);
    }
  }

  public processMessage(pubSubMessage: JhaPubSubMessage): void {
    if (pubSubMessage.message === "LoggedIn") {
      this.loggedIn = true;
    } else if (pubSubMessage.message === "LoggedOut") {
      this.loggedIn = false;
    } else if (pubSubMessage.message === "UserProfile") {
      this.checkPermissions();
    } else if (pubSubMessage.message === "UpdatePermissions") {
      this.checkPermissions();
      this.router.navigate([PFrameRoutes.home]);
    }
  }

  public checkPermissions() {
    this.hasPowerDocPermission = this.hasPermission("view", "powerDocs");
    this.hasPowerScreenPermission = this.hasPermission("view", "powerScreen");
    this.hasPowerBatchPermission = this.hasPermission("view", "powerBatch");
    this.hasSymProfilePermission = this.hasPermission("view", "symProfile");
    this.hasUserManagementPermission = this.hasPermission(
      "view",
      "userManagement"
    );
    this.hasInstManagementPermission = this.hasPermission(
      "view",
      "institutionManagement"
    );
    this.hasUserForumPermission = this.hasPermission("view", "userForum");
    this.hasDeviceProfilePermission = this.hasPermission(
      "view",
      "deviceProfile"
    );
    this.hasServiceConfigPermission = this.hasPermission(
      "view",
      "symProfileBlueprint"
    );
    this.hasManageSymProfilePermission = this.hasPermission(
      "view",
      "symProfile"
    );
    this.hasPowerAdPermission = this.hasPermission("view", "powerAd");
    this.hasManageRoutesPermission = this.hasPermission("view", "manageRoutes");
    this.hasServiceDefinitionPermission = this.hasPermission(
      "view",
      "serviceDefinition"
    );
    this.hasGuestUserPermission = this.hasPermission("view", "guestUser");
    this.hasLogsPermission = this.hasPermission("view", "logs");
    this.hasManageProjectPermission = this.hasPermission(
      "view",
      "manageProjects"
    );
    this.hasMyAppStorePermission =
      this.hasPermission("view", "myPowerFrameApps") &&
      this.dataService.getCurrentInst() === "SYMITAR";

    this.hasReleaseNotesPermission = this.hasPermission(
      "update",
      "releaseNotes"
    );
    this.hasHostManagementPermission = this.hasPermission(
      "view",
      "hostManagement"
    );
    this.hasAuditLogsPermission = this.hasPermission("view", "auditLogs");
  }

  public hasPermission(permission, service) {
    return this.dataService.hasPermission(permission, service, "adminPortal");
  }
}
